import React from "react";
import Template from "../components/core/Auth/Template";

function Signup() {
  return <Template text="Welcome to UniPrep" formType="signup" />;
}

export default Signup;
